<div class="kw-page" [nbSpinner]="this.isLoading">

  <button mat-button class="back-btn" type="button" (click)="back()">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back
  </button>

  <ng-container *ngIf="this.lot">

    <div class="detail-card detail-hero">
      <div class="hero-left">
        <div class="hero-avatar"><fa-icon [icon]="faLayerGroup"></fa-icon></div>
        <div class="hero-info">
          <h1 class="hero-title">{{"Lot" | tenantWords}} {{this.lot.lotNumber}}</h1>
          <p class="hero-subtitle" *ngIf="this.productNames">{{this.productNames}}</p>
          <div class="hero-meta">
            <span class="meta-item" *ngIf="this.lot.farmName">
              <fa-icon [icon]="faTractor" class="meta-icon"></fa-icon>{{this.lot.farmName}}
            </span>
            <span class="meta-item" *ngIf="this.lot.blockName">
              <fa-icon [icon]="faMap" class="meta-icon"></fa-icon>{{this.lot.blockName}}
            </span>
            <span class="meta-item" *ngIf="this.varieties">
              <fa-icon [icon]="faSeedling" class="meta-icon"></fa-icon>{{this.varieties}}
            </span>
          </div>
          <div class="hero-pills">
            <span class="type-pill" *ngFor="let unit of this.unitTotals">
              <span class="pill-kind">{{unit.label}}</span>{{unit.value | number:'1.0-2'}}
            </span>
            <span class="type-pill">
              <span class="pill-kind">Barcodes</span>{{this.barcodeCount | number}}
            </span>
            <span class="type-pill" *ngIf="this.totalWeight > 0">
              <span class="pill-kind">{{"Weight" | tenantWords}}</span>{{this.totalWeight | number:'1.0-2'}}
            </span>
          </div>
        </div>
      </div>

      <div class="hero-actions" *ngIf="this.isAdmin">
        <button mat-raised-button color="primary" class="primary-action" type="button" (click)="editLot()">
          <fa-icon [icon]="faPen" class="me-2"></fa-icon>Edit {{"Lot" | tenantWords}}
        </button>
        <button mat-stroked-button type="button" (click)="moveInventory()">
          <fa-icon [icon]="faTruck" class="me-2"></fa-icon>Move
        </button>
        <button mat-stroked-button type="button" (click)="adjustQuantity()">
          <fa-icon [icon]="faSlidersH" class="me-2"></fa-icon>Adjust Qty
        </button>
        <button mat-stroked-button class="more-btn" type="button" aria-label="More lot actions" [matMenuTriggerFor]="lotMenu">
          <fa-icon [icon]="faEllipsisVertical"></fa-icon>
        </button>
        <mat-menu #lotMenu="matMenu" xPosition="before">
          <button mat-menu-item type="button" (click)="editProduct()">
            <fa-icon [icon]="faBoxes" class="me-2"></fa-icon>Edit {{"Product" | tenantWords}} Code
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="dashboard-sections">
      <div class="summary-row">
        <lot-product-summary [allHandlingUnits]="this.activeHandlingUnits" [lotId]="this.lotId"></lot-product-summary>
        <lot-location-summary [allHandlingUnits]="this.activeHandlingUnits" [lotId]="this.lotId"></lot-location-summary>
      </div>

      <lot-barcode-summary [allHandlingUnits]="this.activeHandlingUnits" [lotId]="this.lotId" [lotNumber]="this.lot.lotNumber">
      </lot-barcode-summary>

      <mass-balance [lotId]="this.lotId"></mass-balance>

      <lot-order-summary *ngIf="this.canViewOrders" [lot]="this.lot"></lot-order-summary>
    </div>

  </ng-container>
</div>
